module.exports = __webpack_public_path__ + "static/img/Mike_Pratt_IMG.dad1bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Desktop/Home_Landing/Mike_Pratt_IMG.png
// module id = 86wY
// module chunks = 0